import { render } from "@/components/pages/dataRecollection/obdOnboardMonitorTest/obdOnboardMonitorTestPage.html?vue&type=template&id=c248a024&external"
import script from "@/components/pages/dataRecollection/obdOnboardMonitorTest/obdOnboardMonitorTestPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/obdOnboardMonitorTest/obdOnboardMonitorTestPage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__